import { useParams } from 'react-router-dom';
import { usePublicProfile } from '@/hooks/usePublicProfile';
import { PublicProfileProvider } from '@/context/PublicProfileContext';
import { ProfileView } from '@/components/shared/ProfileView';
import { ProfileNotFound } from '@/components/shared/ProfileNotFound';
import { PageLoader } from '@/components/shared/PageLoader';

export function CreatorPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading, isError } = usePublicProfile(slug);

  if (isLoading) return <PageLoader label="Loading profile" />;
  if (isError || !data) return <ProfileNotFound />;

  return (
    <>
      <title>{`${data.profile.name} | Nestra`}</title>
      {data.profile.bio && (
        <meta name="description" content={data.profile.bio} />
      )}
      <PublicProfileProvider value={data} tracking>
        <ProfileView />
      </PublicProfileProvider>
    </>
  );
}
